// Visual source of truth: docs/specs/2026-10-17-live-dot-opacity-pulse.md.
// Box and dot sizes are Figma geometry with no token family, so they live in
// component-scoped custom properties.

@layer base-components {
    // The dot (::after) centred in its box, pulsing its opacity. Opacity is
    // the only animated property, so reduced motion keeps the same pulse: a
    // static dot would look like the side nav's unread dot.
    .liveDot {
        --_box: 16px;
        --_size: 6px;
        --_color: var(--fg-tertiary);

        position: relative;
        display: inline-flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        width: var(--_box);
        height: var(--_box);

        &::after {
            content: "";
            position: absolute;
            width: var(--_size);
            height: var(--_size);
            border-radius: 50%;
            background-color: var(--_color);

            // ds-deviation: a 1.2s cycle (600ms each way); the duration tokens
            // stop at 200ms and do not cover looping indicators.
            animation: live-dot-pulse 600ms ease-in-out infinite alternate;
        }
    }

    // The side nav's 5px blue dot.
    .accent {
        --_size: 5px;
        --_color: var(--fg-accent-placeholder);
    }

    .xs {
        --_box: 4px;
        --_size: 4px;
    }
}

@keyframes live-dot-pulse {
    to {
        opacity: 0.3;
    }
}
